import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Mail, RefreshCw, X, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';

export default function EmailVerifyBanner() {
  const { user, api } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  if (!user || user.email_verified || user.auth_provider === 'google' || dismissed) return null;

  const resend = async () => {
    setSending(true);
    try {
      await api('post', '/api/auth/resend-verification');
      toast.success('Verificatie email verstuurd. Check uw inbox.');
    } catch {
      toast.error('Email versturen mislukt. Probeer later opnieuw.');
    }
    setSending(false);
  };

  return (
    <div data-testid="email-verify-banner" style={{
      background: 'linear-gradient(135deg, #fef3c7, #fef9ec)', borderRadius: '12px', padding: '14px 16px',
      display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px',
      border: '1px solid #fde68a',
    }}>
      <Mail size={18} style={{ color: '#d97706', flexShrink: 0 }} />
      <div style={{ flex: 1 }}>
        <p style={{ fontSize: '13px', fontWeight: 600, color: '#92400e' }}>
          Bevestig uw e-mailadres
        </p>
        <p style={{ fontSize: '12px', color: '#a16207', marginTop: '2px' }}>
          We hebben een verificatie email gestuurd naar <strong>{user.email}</strong>.
        </p>
      </div>
      <button
        data-testid="resend-verification-btn"
        onClick={resend}
        disabled={sending}
        style={{
          display: 'flex', alignItems: 'center', gap: '4px', padding: '7px 14px',
          borderRadius: '8px', border: 'none', background: '#d97706', color: 'white',
          fontSize: '12px', fontWeight: 600, cursor: sending ? 'wait' : 'pointer',
          flexShrink: 0,
        }}
      >
        {sending ? <RefreshCw size={12} style={{ animation: 'spin 1s linear infinite' }} /> : <Mail size={12} />}
        Opnieuw versturen
      </button>
      <button onClick={() => setDismissed(true)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#a16207', padding: '4px', flexShrink: 0 }}>
        <X size={14} />
      </button>
    </div>
  );
}
